import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import BaseModal from '../../../components/BaseModal';
import useCreateTeam from '../../../hooks/useCreateTeam';
import InputTeamName from '../../../components/InputTeamName';

const ModalCreateTeam = ({
  visible,
  onCancel,
  onCreateTeam,
  teams,
  loadingModal
}) => {
  const {
    touched,
    isFocus,
    teamName,
    setTeamName,
    alreadyExists,
    isValid,
    onBlur,
    onFocus,
    reset
  } = useCreateTeam(teams);
  
  const onHandleSend = () => onCreateTeam(teamName);

  useEffect(() => {
    if (visible) {
      reset();
    }
  }, [visible, reset]);

  return (
    <BaseModal
      title="Créer une nouvelle équipe"
      visible={visible}
      onHide={onCancel}
      onClick={onHandleSend}
      disabled={!isValid || alreadyExists}
      loading={loadingModal}
    >
      <p className="text-sm text-gray-600 !mb-7">
        Vous pourrez ajouter des membres à cette équipe et créer des offres depuis la page "Mes offres"
      </p>
      <b>{'Choisissez un nom d\'équipe'}</b>
      <InputTeamName
        teamName={teamName}
        touched={touched}
        isFocus={isFocus}
        setTeamName={setTeamName}
        alreadyExists={alreadyExists}
        isValid={isValid}
        onBlur={onBlur}
        onFocus={onFocus}
      />
    </BaseModal>
  );
};

ModalCreateTeam.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onCreateTeam: PropTypes.func.isRequired
};

export default ModalCreateTeam;
